import React, { useState, useEffect } from 'react';
import { auth } from '../Firebase_Config/firebase';
import { updatePassword, reauthenticateWithCredential, EmailAuthProvider } from "firebase/auth";
import Typography from '@mui/material/Typography';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Copyright from '../CopyrightFooter/Copyright';

const AccountManage = () => {
    const [userEmail, setUserEmail] = useState(null);
    const [passwordOne, setPasswordOne] = useState('');
    const [passwordTwo, setPasswordTwo] = useState('');
    const [currentPassword, setCurrentPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const [toastOpen, setToastOpen] = useState(false);
    const [toastSeverity, setToastSeverity] = useState('success');
    const [toastMessage, setToastMessage] = useState('');

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            if (user) setUserEmail(user.email);
            else setUserEmail(null);
        });
        return () => unsubscribe();
    }, []);

    const showToast = (message, severity = 'success') => {
        setToastMessage(message);
        setToastSeverity(severity);
        setToastOpen(true);
    };

    const handleCloseToast = (_, reason) => {
        if (reason === 'clickaway') return;
        setToastOpen(false);
    };

    const reauthenticateUser = async () => {
        const user = auth.currentUser;
        const credential = EmailAuthProvider.credential(user.email, currentPassword);
        try {
            await reauthenticateWithCredential(user, credential);
            return true;
        } catch {
            showToast('Re-authentication failed. Please check your current password.', 'error');
            return false;
        }
    };

    const clearForm = () => {
        setPasswordOne('');
        setPasswordTwo('');
        setCurrentPassword('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (passwordOne !== passwordTwo) {
            showToast('Passwords do not match.', 'error');
            setLoading(false);
            return;
        }

        try {
            await updatePassword(auth.currentUser, passwordOne);
            clearForm();
            showToast('Password updated successfully!', 'success');
        } catch (error) {
            if (error.code === 'auth/requires-recent-login') {
                const reauthenticated = await reauthenticateUser();
                if (reauthenticated) {
                    try {
                        await updatePassword(auth.currentUser, passwordOne);
                        clearForm();
                        showToast('Password updated successfully after re-authentication!', 'success');
                    } catch (err) {
                        showToast(err.message, 'error');
                    }
                }
            } else {
                showToast(error.message, 'error');
            }
        }

        setLoading(false);
    };

    const d = new Date();
    let year = d.getFullYear();

    return (
        <div style={{ backgroundColor: '#ecebf1' }}>
            <div className="accountcontent">
                <div className='ContainerBox'>
                    <div className='accountheader'>
                        <h1 className='accounth1'>Account Management</h1>
                    </div>
                    <div>
                        <h4 className='fontChange'>Want to Change your Password?</h4>
                        <p className='fontChange'>Enter your new password and then repeat. Then click the reset button.</p>
                        {userEmail && (
                            <p className='fontChange'>Logged in as: {userEmail}</p>
                        )}

                        <form onSubmit={handleSubmit}>
                            <input
                                className="form_inputUp"
                                type="password"
                                placeholder="Current Password"
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                            />
                            <input
                                className="form_inputUp"
                                type="password"
                                placeholder="New Password"
                                value={passwordOne}
                                onChange={(e) => setPasswordOne(e.target.value)}
                            />
                            <input
                                className="form_inputUp"
                                type="password"
                                placeholder="Confirm Password"
                                value={passwordTwo}
                                onChange={(e) => setPasswordTwo(e.target.value)}
                            />
                            <button className="Signbutton" type="submit" disabled={loading}>
                                {loading ? 'Updating...' : 'Reset Password'}
                            </button>
                        </form>

                        <p className='fontChange'>Any problems that you cannot resolve please contact support.</p>
                    </div>
                    
                </div>
               
            </div>

            <Snackbar open={toastOpen} autoHideDuration={4000} onClose={handleCloseToast} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <MuiAlert onClose={handleCloseToast} severity={toastSeverity} sx={{ width: '100%' }} elevation={6} variant="filled">
                    {toastMessage}
                </MuiAlert>
            </Snackbar>
           <Copyright/>
        </div>
    );
};

export default AccountManage;
